import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { IProps } from './models';

export const ResultsBlock: FC<IProps> = ({ children, styles = {}, wrap = true }) => {
    return (
        <div
            className={cn(styles.block, {
                [styles.wrap]: wrap,
            })}
        >
            {children}
        </div>
    );
};
